/*! Bookeaz — restrict hyperlocal results to the nearest seller only */
(function () {
  'use strict';
  var DETAILS_KEY = 'wk_seller_details_for_hyp';
  var IDS_KEY = 'wk_seller_ids';
  var IDS_STR_KEY = 'wk_seller_ids_str_hyp';
  var STORES_KEY = 'wk_seller_stores';
  var ENC_KEY = 'wk_encrypted_seller_ids';
  var nativeSetItem = Storage.prototype.setItem;

  Storage.prototype.setItem = function (key, value) {
    if (this === window.localStorage && key === DETAILS_KEY) {
      try {
        var details = JSON.parse(value);
        var keys = Object.keys(details || {});
        if (keys.length > 1) {
          var nearestKey = null, nearestDist = Infinity;
          keys.forEach(function (k) {
            var d = parseFloat(details[k] && details[k].customer_distance);
            if (!isNaN(d) && d < nearestDist) { nearestDist = d; nearestKey = k; }
          });
          if (nearestKey === null) nearestKey = keys[0];
          var nearest = details[nearestKey];
          var filtered = {};
          filtered[nearestKey] = nearest;
          window.__bookeazNearestSeller = nearest;
          value = JSON.stringify(filtered);
        } else {
          window.__bookeazNearestSeller = null;
        }
      } catch (e) { window.__bookeazNearestSeller = null; }
    } else if (this === window.localStorage && window.__bookeazNearestSeller) {
      if (key === IDS_STR_KEY) value = String(window.__bookeazNearestSeller.id_seller);
      else if (key === IDS_KEY) value = JSON.stringify([window.__bookeazNearestSeller.id_seller]);
      else if (key === STORES_KEY) value = JSON.stringify([window.__bookeazNearestSeller.sp_store_name]);
      else if (key === ENC_KEY) value = '';
    }
    return nativeSetItem.call(this, key, value);
  };
})();